import React, { useEffect, useState } from "react";
import "./CSS/dashboard.css";
import { useHistory } from "react-router-dom/cjs/react-router-dom.min";
import { connect } from "react-redux";
import loading_ from "../Assets2/loading.gif";

const Dashboard = (props) => {
  const history = useHistory();

  const [pages, Set_Pages] = useState([]);
  const [vrf_control, Set_vrf_control] = useState([]);
  const [su_depoları, Set_su_depoları] = useState([]);
  const [enerji_izleme, Set_enerji_izleme] = useState([]);
  const [fanlar, Set_fanlar] = useState([]);
  const [sıcak_su, Set_sıcak_su] = useState([]);
  const [pompa_hidrofor, Set_pompa_hidrofor] = useState([]);
  const [crown, Set_crown] = useState([]);
  const [dashboard, Set_dashboard] = useState(false);


  useEffect(() => {
    console.log(props.yetkilendirme_state, props.uid);

    // Find user yetkilendirme from users_list instead
    if (props.uid !== "" && props.users_list && props.users_list.length > 0) {
      const user = props.users_list.find(u => u.userId === props.uid);
      if (user && user.yetkilendirme) {
        const yetki_parse = JSON.parse(user.yetkilendirme);
        const com_id = props.temp_com_id || 1;
        const is_objectExist = yetki_parse[com_id];

        if (is_objectExist) {
          Object.entries(is_objectExist).forEach((x) => {
        console.log(x);
        if (x[0] === "VRF") {
          if (x[1].O === "t") {
            Set_vrf_control(true);
          } else {
            Set_vrf_control(false);
          }
        } else if (x[0] === "Sıcak Su") {
          if (x[1].O === "t") {
            Set_sıcak_su(true);
          } else {
            Set_sıcak_su(false);
          }
        } else if (x[0] === "Su Depoları") {
          if (x[1].O === "t") {
            Set_su_depoları(true);
          } else {
            Set_su_depoları(false);
          }
        } else if (x[0] === "Pompa/Hidrofor") {
          if (x[1].O === "t") {
            Set_pompa_hidrofor(true);
          } else {
            Set_pompa_hidrofor(false);
          }
        } else if (x[0] === "Fanlar") {
          if (x[1].O === "t") {
            Set_fanlar(true);
          } else {
            Set_fanlar(false);
          }
        } else if (x[0] === "Enerji İzleme") {
          if (x[1].O === "t") {
            Set_enerji_izleme(true);
          } else {
            Set_enerji_izleme(false);
          }
        } else if (x[0] === "Crown") {
          if (x[1].O === "t") {
            Set_crown(true);
          } else {
            Set_crown(false);
          }
        } else if (x[0] === "Dashboard") {
          if (x[1].O === "t") {
            Set_dashboard(true);
          } else {
            Set_dashboard(false);
          }
        }
      });
        }
      }
    }
    console.log(props.uid);
  }, [props.uid, props.users_list, props.temp_com_id]);

  useEffect(() => {
    if (props.pages && props.pages.length > 0) {
      Set_Pages(props.pages);
    }
  }, [props.pages]);

  return (
    <main>
      <section style={{ height: "100%" }}>
        {props.tag_values &&
          (props.tag_values.length < 1 ? (
            <div
              style={{
                height: "100vh",
                display: "flex",
                flexDirection: "column",
                alignItems: "center",
                justifyContent: "center",
              }}
              className="loading"
            >
              <img style={{ width: "15%" }} src={loading_} alt="" />
              <h5
                style={{
                  fontFamily: "sans-serif",
                  fontWeight: "600",
                  fontSize: "1.2em",
                  color: "rgb(40,30,40)",
                  marginTop: "30px",
                  fontFamily: "Segoe UI, Tahoma, Geneva, Verdana, sans-serif",
                }}
              >
                Veriler Yükleniyor. Lütfen Bekleyiniz...
              </h5>
            </div>
          ) : (
            <div className="grid_display_bu">
              <div className="grid-display">
                {/*  <button>Isıtma Sistemleri</button>
              <button>Klima Sant. ve Hücreli Fanlar</button> */}
                <button
                  disabled={dashboard === true ? false : true}

                  onClick={() => {
                    history.push("/dashboard");
                  }}
                >
                  Dashboard
                </button>

                <button
                  disabled={sıcak_su === true ? false : true}
                  onClick={() => {
                    history.push("/hot_water_system");
                  }}
                >
                  Sıcak Su Sistemi
                </button>
                <button
                  disabled={vrf_control === true ? false : true}
                  onClick={() => {
                    history.push("/VRF");
                  }}
                >
                  VRF Sistemler ve Split Klimalar
                </button>
                <button
                  disabled={pompa_hidrofor === true ? false : true}
                  onClick={() => {
                    history.push("/pumps_system");
                  }}
                >
                  Pompa ve Hidrofor Sistemler
                </button>
                <button
                  disabled={fanlar === true ? false : true}
                  onClick={() => {
                    history.push("/fans");
                  }}
                >
                  Fanlar
                </button>
                <button
                  disabled={enerji_izleme === true ? false : true}
                  onClick={() => {
                    history.push("/energy");
                  }}
                >
                  Enerji İzleme{" "}
                </button>
                <button
                  disabled={su_depoları === true ? false : true}
                  onClick={() => {
                    history.push("/su_depolari");
                  }}
                >
                  Su Depoları{" "}
                </button>
                {/* <button
                style={{display:crown?`grid`:"none"}}
                  disabled={crown === true ? false : true}
                  onClick={() => {
                    history.push("/crownhomepage");
                  }}
                >
                  Crown Plaza{" "}
                </button> */}
              </div>
            </div>
          ))}
      </section>
    </main>
  );
};
const MapStateToProps = (state) => {
  return {
    pages: state.project_reducer.pages,
    tag_values: state.project_reducer.tag_values,
    uid: state.auth_reducer.user_id,
    yetkilendirme_state: state.project_reducer.yetkilendirme_state,
    users_list: state.project_reducer.users_list,
    temp_com_id: state.project_reducer.temp_com_id,
  };
};
export default connect(MapStateToProps)(Dashboard);
